import React from 'react'
import { Link } from 'react-router-dom'
import '../extend/ExtendModal.css'

const ExtendModal = () => {
  return (
    
    <div className='modal-box-sec extend-modal-sec'>
        <div className="modal fade" id="staticBackdrop11" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div class="modal-body">
                        <div className='top-head text-center'>
                            <p>Your booking is about to end, would you like to request an extension with Chloe?</p>
                        </div>
                        <ul className='d-flex align-content-center justify-content-center gap-2'>
                            <li>
                                <Link rel='stylesheet' to='/' className='btn btn-border'>Yes</Link>
                            </li>
                            <li>
                                <Link rel='stylesheet' to='/' className='btn btn-border'>No</Link>
                            </li>
                        </ul>
                        <form action="">
                            <div className='form-group col-md-12 d-flex align-items-center'>
                                <label htmlFor="" className=''>Extend by:</label>
                                <input type="text" className="form-control" id="" placeholder="00.00" />
                            </div>
                            <div className='btn btn-group align-items-center m-auto d-flex justify-content-center'>
                                <Link rel='stylesheet' to="/" className='btn btn-border'>Send</Link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default ExtendModal
